// BillingPageSkeleton.jsx
import React from "react";
import "./billingPageSkeleton.css";

const BillingPageSkeleton = () => {
	return (
		<div className="sf-billingpage">
			<div className="sf-billing-main">
				
				{/* HEADER */}
				{/* <div className="sf-billing-header-row">
					<div className="sf-skel-back-btn shimmer"></div>
					<div className="sf-skel-title shimmer"></div>
				</div> */}

				<div className="sf-billing-content">
					
					{/* MAIN */}
					<div className="sf-billing-main-part">
						<div className="sf-card sf-skel-card-lg">
							<div className="sf-skel-section-title shimmer"></div>

							<div className="sf-skel-sub-row">
								<div className="sf-skel-sub-left">
									<div className="sf-skel-line shimmer w-60"></div>
									<div className="sf-skel-line shimmer w-40"></div>
									<div className="sf-skel-badge shimmer"></div>
									<div className="sf-skel-line shimmer w-50"></div>
								</div>

								<div className="sf-skel-buttons">
									<div className="sf-skel-btn shimmer"></div>
									<div className="sf-skel-btn shimmer"></div>
								</div>
							</div>
						</div>

						{/* Plans Skeleton */}
						<div className="sf-card sf-skel-card-lg">
							<div className="sf-skel-section-header">
								<div className="sf-skel-section-title shimmer"></div>
								<div className="sf-skel-small shimmer"></div>
							</div>

							<div className="sf-plans-grid">
								{Array.from({ length: 2 }).map((_, i) => (
									<div key={i} className="sf-plan-card">
										<div className="sf-skel-line shimmer w-40"></div>
										<div className="sf-skel-line shimmer w-70"></div>
										<div className="sf-skel-line shimmer w-30"></div>
										<div className="sf-skel-btn-full shimmer"></div>
									</div>
								))}
							</div>
						</div>
					</div>

					{/* SIDEBAR */}
					<div className="sf-billing-sidebar">
						<div className="sf-card sf-sidebar-card">
							<div className="sf-skel-section-title shimmer"></div>

							<div className="sf-skel-line shimmer"></div>
							<div className="sf-skel-line shimmer"></div>
							<div className="sf-skel-line shimmer"></div>
						</div>

						<div className="sf-card sf-sidebar-card">
							<div className="sf-skel-section-title shimmer"></div>

							<div className="sf-skel-line shimmer"></div>
							<div className="sf-skel-line shimmer"></div>
							<div className="sf-skel-line shimmer"></div>
							<div className="sf-skel-line shimmer"></div>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
};

export default BillingPageSkeleton;
